"use strict";
var ng2_scrollable_directive_1 = require("./ng2-scrollable.directive");
exports.Ng2ScrollableDirective = ng2_scrollable_directive_1.Ng2ScrollableDirective;
var ng2_scrollable_module_1 = require("./ng2-scrollable.module");
exports.Ng2ScrollableModule = ng2_scrollable_module_1.Ng2ScrollableModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-scrollable/dist/index.js
// module id = 50
// module chunks = 0